var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMarketplaceBg(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 772,
    height: 363,
    viewBox: "0 0 772 363",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1682_32470)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M497.305 219.455C570.608 219.455 630.032 160.031 630.032 86.7274C630.032 13.4241 570.608 -46 497.305 -46C424.001 -46 364.577 13.4241 364.577 86.7274C364.577 160.031 424.001 219.455 497.305 219.455Z",
    stroke: "#E9E9E9",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M690.17 219.455C763.473 219.455 822.897 160.031 822.897 86.7274C822.897 13.4241 763.473 -46 690.17 -46C616.866 -46 557.442 13.4241 557.442 86.7274C557.442 160.031 616.866 219.455 690.17 219.455Z",
    stroke: "#E9E9E9",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M312.727 409.002C386.031 409.002 445.455 349.578 445.455 276.275C445.455 202.971 386.031 143.547 312.727 143.547C239.424 143.547 180 202.971 180 276.275C180 349.578 239.424 409.002 312.727 409.002Z",
    stroke: "#E9E9E9",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M505.593 409.002C578.896 409.002 638.32 349.578 638.32 276.275C638.32 202.971 578.896 143.547 505.593 143.547C432.289 143.547 372.865 202.971 372.865 276.275C372.865 349.578 432.289 409.002 505.593 409.002Z",
    stroke: "#E9E9E9",
    strokeWidth: 10,
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1682_32470"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 772,
    height: 363,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMarketplaceBg);
export default __webpack_public_path__ + "static/media/marketplace_bg.7a2401359caae1b744c1d3827f8a28dd.svg";
export { ForwardRef as ReactComponent };